module.exports = __webpack_public_path__ + "img/monika-schroll.092b9da6.jpg";